var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "8",
      "md": "4"
    }
  }, [_c('v-card', _vm._b({
    staticClass: "elevation-12"
  }, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-title', [_c('span', [_vm._v(" 참여코드 입력 ")])]), _c('v-card-subtitle', {
    staticClass: "font-size-14 grey--text text--lighten-2"
  }, [_c('span', [_vm._v(" 전달받은 참여코드를 입력해주세요 ")])]), _c('v-card-text', [_c('v-form', [_c('v-text-field', _vm._b({
    ref: "code-input",
    on: {
      "input": _vm.onCodeInput,
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enter($event);
      }
    },
    model: {
      value: _vm.code,
      callback: function callback($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  }, 'v-text-field', Object.assign({}, _vm.attrs_input, {
    errorMessages: _vm.errorMessages,
    hideDetails: 'auto',
    placeholder: '참여코드'
  }), false))], 1)], 1), _c('v-card-actions', [_c('v-btn', _vm._b({
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.enter
    }
  }, 'v-btn', {
    disabled: _vm.disabled,
    loading: _vm.loading
  }, false), [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "dense": ""
    }
  }, [_vm._v("mdi-login-variant")]), _c('span', [_vm._v(" 참여하기 ")])], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }